import {
    Button,
    Input, Td,
    Text,
    Tr
} from "@chakra-ui/react";
import { OrcamentoDeptoItem } from "models/orcamento_departamento";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IDynamicRowItem {
  item1: OrcamentoDeptoItem;
  index1: number;
  index: number;
  editItem: (data: OrcamentoDeptoItem, tipo: string, value: string) => void;
  deleteRow1: (value: OrcamentoDeptoItem) => void;
}
const DynamicOrcRowItem = ({
  item1,
  index1,
  index,
  editItem,
  deleteRow1,
}: IDynamicRowItem) => {
  const [descricao, setDescricao] = useState("");
  const [total, setTotal] = useState(0);

  const changeDescricao = (item: string) => {
    setDescricao(item);
  };

  const changeValor = (item: string) => {
    setTotal(Number(item));
  };

  const calculate = (item: string) => {
    editItem(item1, "valor", item);

    const totalUn = Number(item);
    setTotal(totalUn);
    changeValor(totalUn.toString());
  };

  useEffect(() => {
    if (item1) {
      setDescricao(item1.descricao);
      setTotal(item1.valorTotal);
    }
  }, [item1]);
  return (
    <Tr>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontWeight={"bold"}
          fontSize={14}
          alignSelf={"center"}
        >
          {index + 1}. {index1 + 1}
        </Text>
      </Td>
      <Td>
        <Input
          isRequired={false}
          fontSize="sm"
          value={descricao}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Digite a Descrição"
          fontWeight="500"
          name={`descricao--${index1}-${descricao}`}
          border={"none"}
          size="md"
          onChange={(e) => changeDescricao(e.target.value)}
          onBlur={(e) => editItem(item1, "descricao", e.target.value)}
        />
      </Td>
      <Td>
        <Input
          isRequired={false}
          fontSize="sm"
          value={total}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="valor"
          name={`valor--${index1}-${total}`}
          fontWeight="500"
          border={"none"}
          size="md"
          onChange={(e) => changeValor(e.target.value)}
          onBlur={(e) => calculate(e.target.value)}
        />
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={14}
          alignSelf={"center"}
          width={150}
        >
          {formatNumber(Number(total))}
        </Text>
      </Td>
      <Td>
        <Button
          onClick={() => deleteRow1(item1)}
          colorScheme="red"
          variant="ghost"
          ml="1"
        >
          Excluir
        </Button>
      </Td>
    </Tr>
  );
};
export default DynamicOrcRowItem;
